import {hookToAttributeSelector as byHook, focusElement, handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {useSettings} from '@wix/tpa-settings/react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Check} from '@wix/wix-ui-icons-common'
import classNames from 'classnames'
import React, {useEffect, useRef} from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {settingsParams} from '../../../../settingsParams'
import {FormStep} from '../../../constants'
import c from '../../classnames.scss'
import {StepProps} from './interfaces'
import s from './step.scss'
import {classes} from './step.st.css'

export const Step: React.FC<StepProps> = ({
  stepKey,
  title,
  index,
  editing,
  completed,
  indexVisible,
  dividerVisible,
  renderStep,
  onEdit,
  t,
  scrollToElement,
}) => {
  const settings = useSettings()

  const disabled = !editing && !completed
  const collapsed = completed && !editing
  const editAction = () => onEdit(stepKey)
  const stepRef = useRef<HTMLDivElement>(null)
  const formTitleTag = settings.get(settingsParams.formTitleTag) as string

  useEffect(() => {
    if (editing && stepKey !== FormStep.BuyerDetails) {
      setTimeout(() => {
        scrollToElement(stepKey)
      }, 15)
    }
  }, [editing, stepKey])

  useEffect(() => {
    if (editing && !completed) {
      setTimeout(() => {
        focusElement({selector: `${byHook(DH.CHECKOUT_STEP(stepKey))} ${byHook(DH.CHECKOUT_STEP_TITLE)}`})
      }, 10)
    }
  }, [editing, completed])

  return (
    <div
      ref={stepRef}
      data-hook={DH.CHECKOUT_STEP(stepKey)}
      id={stepKey}
      className={classNames(s.container, {[s.opened]: editing, [s.disabled]: disabled})}
    >
      {dividerVisible && <div className={classNames(s.divider, c.formTitleColor)} />}
      <div className={s.content}>
        <div className={classNames(s.row, s.titleContainer, c.formTitleFont, c.formTitleColor)}>
          <Text
            data-hook={DH.CHECKOUT_STEP_TITLE}
            className={classNames(s.title, s.row, classes.title, disabled ? classes.disabled : classes.active)}
            tagName={formTitleTag}
          >
            {(indexVisible || collapsed) && (
              <span className={s.titleLeft}>
                {collapsed ? <Check size="1.5em" className={s.check} /> : `${index}.`}
              </span>
            )}
            {title}
          </Text>
          {collapsed && (
            <div
              data-hook={DH.CHECKOUT_STEP_EDIT}
              className={classNames(s.edit, s.linkColor)}
              onClick={editAction}
              onKeyDown={handleKeyPressEnterOrSpace(editAction)}
              tabIndex={0}
            >
              {t('mobile.checkout.edit')}
            </div>
          )}
        </div>
        {!disabled && renderStep(editing)}
      </div>
    </div>
  )
}
